module.exports = __webpack_public_path__ + "img/img4zhCn.567f8335.png";